export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-21.jpg'),
        title: 'ゲーム分野',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'ゲーム分野',
      description: `<p>世界のアウトソーシング市場の大きなシェアを占めるコア事業として、2D/3Dアーティスト、アニメーター、UI/UXデザイナーで構成される専門チームを有しています。UnityやUnrealなど主要エンジンに精通し、あらゆるスタイル・ジャンルのアート資産制作に対応可能で、200以上のプロジェクトを納品し、合計ダウンロード数は1億回を超えます。</p>
<p>ゲーム産業が1800億ドル規模に達し、プレイヤーの品質要求が高まる中、ゲームの外注は「コスト削減ツール」から「戦略的パートナー」へと進化しています。当社は長年ゲーム外注に注力し、「技術主導・品質重視・柔軟適応」を理念に、アート制作、プログラム開発、テスト・運用までのワンストップアウトソーシングを提供し、クライアントのコアクリエイティブに集中できる体制を支援します。インディーからAAA規模まで、カスタマイズされたサービスで開発のボトルネックを解消し、品質と効率の両立を実現します。</p>`
    },
    {
      title: '当社の強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-21.jpg')+`)"></span>
      <span class="list">
      <i></i>高度な開発チームと先進的なコア技術。<br/>
      <i></i>グローバルな流通ネットワークと主要市場へのカバレッジ。<br/>
      <i></i>豊富なIPと多様なゲームジャンルの経験。<br/>
      <i></i>継続的なイノベーションで業界の最先端を追随。<br/>
      <i></i>追加コストなしでの対応可能性。<br/>
      </span>`
    }
  ]
}
